import React from "react";

import "./styles.css";

const Row = (props) => {
    const {title, value, span} = props;
    return (
        <div className="result-row">
            <p className="result-row-right">
                {title}
            </p>
            <p className="result-row-left">
                {value} {span ? null : <span style={{color: "#C2CDD9"}}>تومان</span>}
            </p>
        </div>
    );
};
export default React.memo(Row);